import { resolveThunkSelector } from '@app/packages/thunkSelector/thunkSelector'

import { profileUserSelector } from '@app/store/slices/profile'
import { requestsWithDebtIdsResultSelector } from '@app/store/slices/requests'
import { createThunk } from '@app/store/thunk'

import { assertMountPush } from '@app/components/Mount/actions'

/**
 * @param _syncHash Used to ensure that profile is updated before calling the action
 */
export function requireNoDebts(_syncHash: string) {
  return createThunk<Promise<boolean>>(async (dispatch, getState) => {
    const user = profileUserSelector(getState())
    if (!user || user.account_type !== 'parent') return true

    const list = await dispatch(resolveThunkSelector(requestsWithDebtIdsResultSelector))
    if (!list.length) return true

    const { promise, resolve } = Promise.withResolvers<boolean>()
    const close = await dispatch(
      assertMountPush(
        import('@app/components/DebtsModal/DebtsModal').then(m => m.DebtsModal),
        { props: { onChange: resolve } }
      )
    )
    const result = await promise
    await close()
    return result
  })
}
